import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme, alpha } from '@mui/material/styles';
import { EmbersInput } from '../input';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_NEUTRAL_PLUM, PROMETHEAN_TEXT, PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_GREY_200, PROMETHEAN_NEUTRAL_GREY_800, PROMETHEAN_FOCUS_OUTLINE } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SMALL_TEXT, PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_SUBTITLE_03 } from '../styles/typography/typography';
import { PROMETHEAN_SPACER_MD, PROMETHEAN_SPACER_XL, PROMETHEAN_SPACER_SM } from '../styles/typography/spacer';
import { PROMETHEAN_HEAVY_SHADOW } from '../styles/elevation/elevation';
import { DatePicker, DateRangePickerDay as MuiDateRangePickerDay } from './lab/src';
import { styled } from '@mui/system';
import { EmbersPopper } from '../popper/popper';
var divider = "1px solid ".concat(alpha(PROMETHEAN_NEUTRAL_DARK_GREY, 0.5));
export var DateMenu = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  '&.EmbersDateSelect-customRangle-selected': {
    transition: 'all linear 0.3s'
  },
  '.EmbersDateSelect-menu': {
    width: '100%',
    maxHeight: 'inherit',
    '&.EmbersDateSelect-open': {
      width: 'inherit'
    }
  }
});
export var DateRangePopper = styled(EmbersPopper)({
  '&.EmbersDateRangePopper-single': {
    '.MuiCollapse-wrapperInner': {
      margin: '0 12px',
      '.EmbersDateCalendar-input': {
        margin: '23px 8px 0'
      }
    }
  },
  '&.EmbersDateRangePopper-range': {
    '.MuiCollapse-wrapperInner': {
      margin: '0 16px 0 8px',
      '.EmbersDateRangeCalendar-dateRangeField': {
        margin: '24px 0 0 8px',
        height: 87,
        '.EmbersInput-root': {
          margin: 0
        }
      },
      '.MuiPickerStaticWrapper-root': {
        height: 286.5
      }
    }
  }
});
export var StyledDateCalendar = styled('div')({
  '.EmbersDateCalendar-input': {
    margin: '0 8px',
    '.MuiTextField-root': {
      width: '100%'
    }
  },
  '.EmbersRangePicker-root': {
    marginTop: 12
  }
});
export var StyledDateField = styled(EmbersInput)(function (props) {
  return {
    width: props.fullWidth ? '100%' : 224,
    height: 87,
    '.Mui-disabled': {
      '.EmbersDatePicker-inputIcon': {
        color: PROMETHEAN_NEUTRAL_DARK_GREY,
        cursor: 'default',
        '&:focus-visible': {
          outline: 'none'
        }
      }
    },
    '.EmbersDatePicker-inputIcon': {
      border: 'none',
      background: 'none',
      padding: 0,
      color: PROMETHEAN_TEXT,
      cursor: 'pointer',
      '&:focus-visible': {
        outline: PROMETHEAN_FOCUS_OUTLINE,
        outlineOffset: -2
      }
    }
  };
});
export var StyledDatePicker = styled(DatePicker)({
  '.EmbersDatePicker-dateField': {
    width: 240,
    '.EmbersDatePicker-inputIcon': {
      paddingRight: 12,
      '.MuiIconButton-edgeEnd:focus-visible': {
        borderRadius: 0,
        outline: PROMETHEAN_FOCUS_OUTLINE,
        outlineOffset: -2
      }
    },
    '.icon-calendar': {
      color: PROMETHEAN_TEXT
    }
  }
});
export var StyledDateRangeField = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  borderBottom: divider,
  height: 88,
  margin: '8px 0 0 8px',
  '.EmbersInput-root': {
    width: 220,
    margin: 0
  },
  '.icon-arrow': {
    margin: '19px 8px 0px 8px'
  }
});

// DateRangeCalendar
export var StyledDateRangeCalender = styled('div')({
  width: 496,
  '.MuiTextField-root': {
    width: '100%'
  },
  '.EmbersDateRangePickerView-column': {
    'div[role="row"]': {
      marginTop: '-1px !important'
    },
    'div[role="row"]:first-of-type': {
      marginTop: '0px !important'
    },
    '&-0': {
      '.EmbersPickersCalendar-week-caption': {
        padding: "0 ".concat(PROMETHEAN_SPACER_MD, " 0 0"),
        borderRight: divider
      }
    },
    '&-1': {
      '.EmbersPickersCalendar-week-caption': {
        padding: "0 0 0 ".concat(PROMETHEAN_SPACER_MD)
      }
    }
  }
});
export var DateRangePickerDay = styled(MuiDateRangePickerDay)(function (_ref) {
  var isHighlighting = _ref.isHighlighting,
    isStartOfHighlighting = _ref.isStartOfHighlighting,
    isEndOfHighlighting = _ref.isEndOfHighlighting,
    selected = _ref.selected;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isHighlighting && {
    borderRadius: 0,
    backgroundColor: PROMETHEAN_NEUTRAL_PLUM,
    '&:hover, &:focus': {
      backgroundColor: PROMETHEAN_NEUTRAL_PLUM
    }
  }), isStartOfHighlighting && {
    backgroundColor: PROMETHEAN_PURPLE_GRAPE
  }), isEndOfHighlighting && {
    backgroundColor: PROMETHEAN_PURPLE_GRAPE
  }), selected && {
    backgroundColor: PROMETHEAN_NEUTRAL_PLUM
  });
});
export var DateRangeFooter = styled('div')({
  '&.EmbersDateRangeTypeFooter-root': {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    padding: '16px 0',
    paddingLeft: PROMETHEAN_SPACER_MD,
    borderTop: divider,
    '.EmbersDateRangeTypeFooter-buttons': {
      display: 'flex',
      columnGap: 4
    },
    '.EmbersDateRangeTypeFooter-dates': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
      display: 'flex',
      alignItems: 'center',
      columnGap: 6
    })
  }
});
export var StyledDateInput = styled('div')({
  '.EmbersInput-root': {
    minWidth: 240,
    height: 'auto'
  }
});

// DatePicker popper
export var StyledDatePickerPopper = styled(EmbersPopper)({
  padding: '16px 16px 0',
  borderRadius: 8,
  '> div > div': {
    width: 'auto'
  },
  '.MuiInputBase-adornedEnd': {
    paddingRight: 12,
    '.MuiIconButton-edgeEnd:focus-visible': {
      borderRadius: 0,
      outline: PROMETHEAN_FOCUS_OUTLINE,
      outlineOffset: -2
    }
  },
  '.icon-calendar': {
    color: PROMETHEAN_TEXT
  }
});
export var datePickerTheme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, PROMETHEAN_HEAVY_SHADOW), {}, {
          padding: '16px 16px 0',
          borderRadius: 8,
          '> div > div': {
            width: 'auto'
          }
        })
      }
    },
    /* Single date picker */
    // @ts-ignore
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          margin: 0,
          width: 240,
          padding: '0 8px 16px 8px',
          // month/year pagination
          '& > div:first-of-type': {
            padding: '0 0 8px 0',
            margin: 0,
            maxHeight: 'none',
            // month/year text
            // two separate pieces, causes text wrapping to be weird
            '& > div:first-of-type': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_03), {}, {
              margin: 'auto',
              width: 176,
              justifyContent: 'center',
              flexWrap: 'wrap',
              maxHeight: 'none',
              '& > div:first-of-type': {
                overflowWrap: 'anywhere'
              }
            }),
            // pagination arrows
            '& > div:nth-of-type(2)': {
              position: 'absolute',
              div: {
                width: 176
              }
            }
          },
          '.MuiButtonBase-root:not(.MuiPickersDay-root)': {
            padding: 0,
            margin: 0,
            color: PROMETHEAN_TEXT,
            '&.Mui-disabled': {
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            },
            '&:focus-visible': {
              borderRadius: 0,
              outline: "2px solid ".concat(PROMETHEAN_BLUE),
              outlineOffset: -2
            }
          },
          // days of the week
          '.MuiTypography-caption': _objectSpread(_objectSpread({
            margin: 0
          }, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
            color: PROMETHEAN_NEUTRAL_GREY_800
          })
        }
      }
    },
    /* Date range picker */
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: {
          paddingTop: 12.31,
          '.Mui-DateRangeView-root': {
            color: PROMETHEAN_TEXT,
            margin: PROMETHEAN_SPACER_MD,
            marginTop: 0,
            // first month
            '.Mui-DateRangeArrows-row': {
              display: 'flex',
              flexDirection: 'row',
              width: 480,
              '.MuiIconButton-root': {
                color: PROMETHEAN_TEXT,
                '&:focus-visible': {
                  borderRadius: 0,
                  outline: PROMETHEAN_FOCUS_OUTLINE,
                  outlineOffset: -2
                },
                '&.Mui-disabled': {
                  color: PROMETHEAN_NEUTRAL_DARK_GREY
                }
              },
              // month/year pagination
              '& > div:nth-of-type(1)': {
                width: 240,
                justifyContent: 'flex-start',
                padding: "0 0 ".concat(PROMETHEAN_SPACER_SM, " 0"),
                '.MuiTypography-subtitle1': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_03), {}, {
                  width: 176,
                  textAlign: 'center'
                })
              },
              // month/year pagination
              '& > div:nth-of-type(2)': {
                width: 240,
                justifyContent: 'flex-end',
                padding: "0 0 ".concat(PROMETHEAN_SPACER_SM, " 0"),
                '.MuiTypography-subtitle1': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_03), {}, {
                  width: 176,
                  textAlign: 'center'
                })
              }
            },
            '.Mui-DateRangePickerView': {
              display: 'flex',
              flexDirection: 'row',
              '> .EmbersDateRangePickerView-column-0': {
                position: 'relative',
                borderRight: 'none',
                width: 240,
                '&:after': {
                  content: '""',
                  position: 'absolute',
                  borderRight: divider,
                  right: 0,
                  top: 32,
                  height: 'calc(100% - 32px)'
                },
                // days table
                '.PrivatePickersSlideTransition-root': {
                  marginRight: PROMETHEAN_SPACER_MD,
                  width: 224,
                  minWidth: 224,
                  '& > div > div': {
                    margin: 0
                  }
                }
              },
              '> .EmbersDateRangePickerView-column-1': {
                width: 240,
                // days table
                '.PrivatePickersSlideTransition-root': {
                  marginLeft: PROMETHEAN_SPACER_MD,
                  width: 224,
                  minWidth: 224,
                  '& > div > div': {
                    margin: 0
                  }
                }
              }
            }
          },
          '.MuiButtonBase-root': {
            padding: 0,
            transform: 'scale(1)'
          },
          // days of the week
          '.MuiTypography-caption': _objectSpread(_objectSpread({
            margin: 0
          }, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
            color: PROMETHEAN_NEUTRAL_GREY_800,
            width: PROMETHEAN_SPACER_XL,
            height: PROMETHEAN_SPACER_XL
          })
        },
        // @ts-ignore
        viewTransitionContainer: {
          margin: '0 16px',
          paddingTop: PROMETHEAN_SPACER_MD,
          borderTop: '1px solid #CCCCCC',
          '& > div:first-of-type': {
            '& > div:nth-of-type(2)': {
              minHeight: 230
            }
          }
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
          backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
          width: PROMETHEAN_SPACER_XL,
          height: PROMETHEAN_SPACER_XL,
          borderRadius: 0,
          margin: 0,
          padding: 0,
          '&.Mui-disabled': {
            color: PROMETHEAN_NEUTRAL_DARK_GREY,
            '&.MuiPickersDay-today': {
              color: PROMETHEAN_TEXT
            }
          },
          '&.MuiPickersDay-today': {
            backgroundColor: PROMETHEAN_NEUTRAL_GREY_200,
            border: 'none',
            '&:focus-visible': {
              borderColor: PROMETHEAN_NEUTRAL_GREY_200,
              backgroundColor: PROMETHEAN_NEUTRAL_GREY_200,
              border: 'none'
            }
          },
          '&.Mui-selected, &:focus.Mui-selected': {
            backgroundColor: PROMETHEAN_PURPLE_GRAPE,
            color: PROMETHEAN_NEUTRAL_WHITE,
            transform: 'none',
            '&:hover': {
              backgroundColor: PROMETHEAN_PURPLE_GRAPE
            },
            '&:focus-visible': {
              color: PROMETHEAN_NEUTRAL_WHITE,
              backgroundColor: PROMETHEAN_PURPLE_GRAPE,
              border: 'none'
            }
          },
          '&:focus-visible': {
            width: 26,
            height: 26,
            outlineOffset: 1,
            margin: 3,
            backgroundColor: PROMETHEAN_NEUTRAL_PLUM,
            outline: "2px solid ".concat(PROMETHEAN_BLUE),
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          },
          '&:hover, &:active': {
            position: 'relative',
            zIndex: 1,
            background: PROMETHEAN_NEUTRAL_PLUM,
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE, "!important")
          }
        })
      }
    },
    MuiDateRangePickerDay: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
          width: PROMETHEAN_SPACER_XL,
          height: PROMETHEAN_SPACER_XL,
          margin: 0,
          background: 'none!important',
          div: {
            border: 'none'
          },
          '&:last-of-type': {
            borderRadius: 0
          },
          '&:first-of-type': {
            borderRadius: 0
          },
          '&.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
            position: 'relative',
            zIndex: 1,
            background: "".concat(PROMETHEAN_NEUTRAL_PLUM, " !important")
          },
          '.MuiDateRangePickerDay-dayInsideRangeInterval': {
            position: 'relative',
            borderTop: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
            borderBottom: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
            zIndex: 1,
            '&:after': {
              content: '""',
              display: 'none',
              position: 'absolute',
              top: -1,
              left: 0,
              width: 32,
              height: 32,
              border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
            },
            '&.MuiPickersDay-today': {
              background: PROMETHEAN_NEUTRAL_PLUM,
              borderTop: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
              borderBottom: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
            },
            '&:hover': {
              borderTop: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
              borderBottom: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
              borderLeft: 'none!important',
              borderRight: 'none!important',
              '&:after': {
                display: 'block'
              }
            }
          },
          '&.EmbersPickerCalendar-column-last, &.MuiDateRangePickerDay-rangeIntervalDayHighlightEnd': {
            '.MuiDateRangePickerDay-dayInsideRangeInterval': {
              borderRight: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
              '&:hover': {
                borderRight: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE, "!important"),
                borderLeft: 'none!important',
                '&:after': {
                  display: 'block',
                  left: 0
                }
              }
            }
          },
          '&.EmbersPickerCalendar-row-endDate': {
            '.MuiDateRangePickerDay-dayInsideRangeInterval': {
              '&:hover': {
                borderTop: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE, "!important"),
                borderBottom: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE, "!important"),
                '&:after': {
                  display: 'block',
                  left: 0
                }
              }
            }
          },
          '&.EmbersPickerCalendar-column-first, &.MuiDateRangePickerDay-rangeIntervalDayHighlightStart': {
            '.MuiDateRangePickerDay-dayInsideRangeInterval': {
              borderLeft: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE),
              '&:hover': {
                borderLeft: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE, "!important"),
                borderRight: 'none!important',
                '&:after': {
                  display: 'block',
                  left: -1
                }
              }
            }
          }
          // '.MuiDateRangePickerDay-nextWeekdayHighlighting': {
          //   borderBottom: 'none'
          // }
        })
      }
    }
  }
});